<template>
  <div class="conversion_analytics" :class="{'amp' : applyData.bAMP}">
    <div class="left">
      <h4><span v-if="!applyData.bAMP"></span>{{ $t('common.inflow') }}</h4>
      <ul class="inflow">
        <li v-for="(item, index) in inflowData.topItems" :key="index" class="item"
          :class="`item-${inflowData.cssOrder[index]}`">
          <div class="item">
            <div class="bg" :style="{ width: item.percentage + '%' }"></div>
          </div>
          <div class="value">
            <ui-url-linker
              :url="item.refer"
              @onUrlLink="openRefererUrl" :option="'refer'">
            </ui-url-linker>
            <p class="meta">
              {{ item.count | thousand }}
              ({{ item.percentage | fixed(1) }}%)
            </p>
          </div>
        </li>
        <li v-if="inflowData.etcCount" class="item"
          :class="`item-${inflowData.cssOrder[inflowData.topItems.length]}`">
          <div class="item">
            <div class="bg" :style="{ width: inflowData.etcPercentage + '%' }"></div>
          </div>
          <div class="value">
            <p class="url">etc</p>
            <p class="meta">
              {{ inflowData.etcCount | thousand }}
              ({{ inflowData.etcPercentage | fixed(1) }}%)
            </p>
          </div>
          <button type="button" v-if="showRefererMore"
            class="btn_more_list" @click="openMore('referer')">
            <span class="icon icon--more"></span>
          </button>
        </li>
      </ul>
    </div>
    <div class="line-left" v-if="!applyData.bAMP">
      <div v-for="(item, index) in inflowData.topItems" :key="index"
        :class="`line line-${inflowData.cssOrder[index]}`"></div>
      <div v-if="inflowData.etcCount"
        :class="`line line-${inflowData.cssOrder[inflowData.topItems.length]}`"></div>
      <div v-if="inflowData.cssOrder.length === 6"
        class="line-arrow"></div>
    </div>

    <div class="page_info" v-if="!applyData.bAMP">
      <strong>{{ applyData.pageName }}</strong>
<!--      <p class="url ellipsis">{{ applyData | applyUrlStr }}</p>-->

      <ui-url-linker
        :url="applyData | applyUrlStr" :type="'center'"
        @onUrlLink="openRefererUrl">
      </ui-url-linker>

      <span class="match_type">{{ applyData.matchType | matchType }}</span>
    </div>

    <div class="line-right" v-if="!applyData.bAMP">
      <div v-for="(item, index) in outflowData.topItems" :key="index"
        :class="`line line-${outflowData.cssOrder[index]}`"></div>
      <div v-if="outflowData.etcCount"
        :class="`line line-${outflowData.cssOrder[outflowData.topItems.length]}`"></div>
      <div v-if="outflowData.exitCount"
        class="line line-exit"></div>
    </div>

    <div class="right" v-if="!applyData.bAMP">
      <h4><span></span>{{ $t('common.conversion') }}</h4>
      <ul class="outflow">
        <li v-for="(item, index) in outflowData.topItems" :key="index" class="item"
          :class="`item-${outflowData.cssOrder[index]}`">
          <div class="item">
            <div class="bg" :style="{ width: item.percentage + '%' }"></div>
          </div>
          <div class="value">
<!--            <button type="button" class="outlink icon icon&#45;&#45;link-size16"-->
<!--              @click="openConversionUrl(item.cvr)"></button>-->
<!--            <p class="url ellipsis">{{ item.cvr }}</p>-->

            <ui-url-linker
              :url="item.cvr"
              @onUrlLink="openConversionUrl" :option="'cvr'">
            </ui-url-linker>
            <p class="meta">
              {{ item.count | thousand }}
              ({{ item.percentage | fixed(1) }}%)
            </p>
          </div>
        </li>
        <li v-if="outflowData.etcCount" class="item"
          :class="`item-${outflowData.cssOrder[outflowData.topItems.length]}`">
          <div class="item">
            <div class="bg" :style="{ width: outflowData.etcPercentage + '%' }"></div>
          </div>
          <div class="value">
            <p class="url">etc</p>
            <p class="meta">
              {{ outflowData.etcCount | thousand }}
              ({{ outflowData.etcPercentage | fixed(1) }}%)
            </p>
          </div>
          <button type="button" class="btn_more_list" @click="openMore('conversion')">
            <span class="icon icon--more"></span>
          </button>
        </li>
        <li v-if="outflowData.exitCount" class="item item-exit">
          <div class="item">
            <span class="icon_exit"></span>
          </div>
          <div class="value">
            <p class="url">{{ $t('common.exit') }}</p>
            <p class="meta">
              {{ outflowData.exitCount | thousand }}
              ({{ outflowData.exitPercentage | fixed(1) }}%)
            </p>
          </div>
        </li>
      </ul>
    </div>
    <etc-list v-if="conversionEtcData"
      :etcData="conversionEtcData"
      @onCloseClick="conversionEtcData = null"
      @onUrlClick="onUrlClick"/>
  </div>
</template>

<script>
import { sum, getPercentage } from '@/libs/utils'
import { getConversionUrl } from '@/libs/analytics-helper'
import EtcList from './EtcList'
import UiUrlLinker from '@/components/ui/UiUrlLinker'

function getTopData (items, topSize, totalCount, exitCount = 0) {
  const topItems = items.slice(0, topSize)
  const topCount = sum(topItems, 'count')
  const etcCount = totalCount - topCount - exitCount
  const etcPercentage = getPercentage(etcCount, totalCount)

  for (const item of topItems) {
    item.percentage = getPercentage(item.count, totalCount)
  }

  return {
    topItems,
    etcCount,
    topCount,
    etcPercentage,
    count: totalCount
  }
}

const INFLOW_TOP_SIZE = 5
const CONVERSION_TOP_SIZE = 4

export default {
  name: 'ConversionAnalytics',
  components: {
    UiUrlLinker,
    EtcList
  },
  props: [
    'conversionData',
    'applyData'
  ],
  data () {
    return {
      conversionEtcData: null
    }
  },
  computed: {
    inflowData () {
      const items = this.conversionData.refererItems
      const totalCount = this.conversionData.totalCount
      const topData = getTopData(items, INFLOW_TOP_SIZE, totalCount)

      let itemCount = topData.topItems.length

      if (topData.etcCount) {
        itemCount++
      }

      let cssOrder

      switch (itemCount) {
        case 1:
          cssOrder = [3]
          break
        case 2:
          cssOrder = [3, 4]
          break
        case 3:
          cssOrder = [2, 3, 4]
          break
        case 4:
          cssOrder = [2, 3, 4, 5]
          break
        case 5:
          cssOrder = [1, 2, 3, 4, 5]
          break
        case 6:
          cssOrder = [1, 2, 3, 4, 5, 6]
          break
        default:
          cssOrder = []
      }

      topData.cssOrder = cssOrder
      return topData
    },
    outflowData () {
      const items = this.conversionData.items
      const totalCount = this.conversionData.totalCount
      const exitCount = totalCount - this.conversionData.conversionCount
      const topData = getTopData(items, CONVERSION_TOP_SIZE, totalCount, exitCount)
      topData.exitCount = exitCount
      topData.exitPercentage = getPercentage(exitCount, totalCount)

      let itemCount = topData.topItems.length

      if (topData.etcCount) {
        itemCount++
      }

      let cssOrder

      switch (itemCount) {
        case 1:
          cssOrder = [4]
          break
        case 2:
          cssOrder = [3, 4]
          break
        case 3:
          cssOrder = [3, 4, 5]
          break
        case 4:
          cssOrder = [2, 3, 4, 5]
          break
        case 5:
          cssOrder = [1, 2, 3, 4, 5]
          break
        default:
          cssOrder = []
      }

      topData.cssOrder = cssOrder
      return topData
    },
    showRefererMore () {
      return this.conversionData.refererItems.length > INFLOW_TOP_SIZE
    },
    showConversionMore () {
      return this.conversionData.items.length > CONVERSION_TOP_SIZE
    }
  },
  methods: {
    onUrlClick (type, url) {
      if (type === 'referer') {
        this.openRefererUrl(url)
      } else {
        this.openConversionUrl(url)
      }
    },
    openRefererUrl (url) {
      if (url.indexOf('https://') === -1 || url.indexOf('https://') === -1) {
        window.open(`http://${url}`)
      } else {
        window.open(`${url}`)
      }
    },
    openConversionUrl (url) {
      window.open(getConversionUrl(url, this.applyData.hostname))
    },
    openMore (type) {
      this.conversionEtcData = []
      let topSize
      let items
      const totalCount = this.conversionData.totalCount
      let urlFieldName

      if (type === 'referer') {
        items = this.conversionData.refererItems
        topSize = INFLOW_TOP_SIZE
        urlFieldName = 'refer'
      } else {
        items = this.conversionData.items
        topSize = CONVERSION_TOP_SIZE
        urlFieldName = 'cvr'
      }

      this.conversionEtcData = {
        type,
        items: items.slice(topSize).map(item => {
          return {
            url: item[urlFieldName],
            count: item.count,
            percentage: getPercentage(item.count, totalCount)
          }
        })
      }
    }
  }
}
</script>

<style lang="scss">
.conversion_analytics {
  position: relative;

  &.amp {
    position: absolute;
    right: 100px;
    width : 35%;
    height: 100%;
    display: inline-block;
    vertical-align: middle;
    max-width: 500px;

    .left {
      width:100%;
    }
  }

  .left,
  .right {
    position: absolute;
    width: 29.02%;
    top: 0;
    z-index: 10;

    h4 {
      height: 42px;
      box-sizing: border-box;
      text-align: center;
      font-weight: 500;
      font-size: 15px;
      color: #2f2f2f;

      span {
        display: inline-block;
        width: 8px;
        height: 8px;
        border-radius: 4px;
        vertical-align: middle;
        margin-right: 6px;
      }
    }
  }

  .left {
    left: 0;
    h4 span {
      background-color: #43b6c9;
    }
  }

  .right {
    right: 0;
    h4 span {
      background-color: #9fce12;
    }
  }

  .line-left,
  .line-right {
    position: absolute;
    top: 42px;

    .line {
      position: absolute;
      margin-top: 30px;
      width: 100%;
      background-repeat: no-repeat;
      background-position: 0 0;
      background-size: 100% 100%;
    }
  }

  .line-left {
    width: 9.32%;
    left: 28.80%;

    .line-1 {
      height: 197px;
      background-image: url(../../assets/img/analytics/inflow_line1.svg);
    }
    .line-2 {
      top: 80px;
      height: 119px;
      background-image: url(../../assets/img/analytics/inflow_line2.svg);
    }
    .line-3 {
      top: 160px;
      height: 41px;
      background-image: url(../../assets/img/analytics/inflow_line3.svg);
    }
    .line-4 {
      top: calc(240px - 41px);
      height: 41px;
      background-image: url(../../assets/img/analytics/inflow_line4.svg);
    }
    .line-5 {
      top: calc(320px - 119px);
      height: 119px;
      background-image: url(../../assets/img/analytics/inflow_line5.svg);
    }
    .line-6 {
      top: calc(400px - 197px);
      height: 197px;
      background-image: url(../../assets/img/analytics/inflow_line6.svg);
    }
    .line-arrow {
      position: absolute;
      width: 25px;
      height: 27px;
      top: 216px;
      right: 0;
      margin-right: -5px;
      background: url(../../assets/img/analytics/inflow_arrow.svg) no-repeat 0 0;
    }
  }

  .line-right {
    width: 9.30%;
    right: 29.12%;

    .line {
      margin-top: 24px;
    }

    .line-1 {
      height: 203px;
      background-image: url(../../assets/img/analytics/conversion_line1.svg);
    }
    .line-2 {
      top: 80px;
      height: 124px;
      background-image: url(../../assets/img/analytics/conversion_line2.svg);
    }
    .line-3 {
      top: 160px;
      height: 46px;
      background-image: url(../../assets/img/analytics/conversion_line3.svg);
    }
    .line-4 {
      margin-top: 36px;
      top: calc(240px - 46px);
      height: 46px;
      background-image: url(../../assets/img/analytics/conversion_line4.svg);
    }
    .line-5 {
      margin-top: 36px;
      top: calc(320px - 124px);
      height: 124px;
      background-image: url(../../assets/img/analytics/conversion_line5.svg);
    }
    .line-exit {
      width: 91%;
      margin-top: 36px;
      top: calc(400px - 202px);
      height: 202px;
      background-image: url(../../assets/img/analytics/exit_line.svg);
    }
  }

  .left_arrow {
    top: 70px;
    width: 9.55%;
    height: 402px;
    background: url(../../assets/img/analytics_conversion_left.svg) no-repeat 0 0;
    background-size: 100% 402px;
  }
  .right_arrow {
    top: 68px;
    width: 9.38%;
    height: 413px;
    right: 29.02%;
    background: url(../../assets/img/analytics_conversion_right.svg) no-repeat 0 0;
    background-size: 100% 413px;
  }

  .item {
    position: absolute;
    top: 0;
    left: 0;
    height: 60px;
    width: 100%;
    box-sizing: border-box;
    border-radius: 30px;
    //overflow: hidden;

    &::after {
      content: '';
      position: absolute;
      top: 30px;
    }

    &.item-2 {
      top: 80px;
    }
    &.item-3 {
      top: 160px;
    }
    &.item-4 {
      top: 240px;
    }
    &.item-5 {
      top: 320px;
      & > .btn_more_list {
        right: 11px;
      }
    }
    &.item-6,
    &.item-exit {
      top: 400px;
    }

    .bg {
      position: absolute;
      top: 0;
      height: 100%;
      opacity: 0.15;
    }

    .value {

      padding-left: 22px;

      //.outlink {
      //  position: absolute;
      //  top: 10px;
      //  left: 20px;
      //}
      & > .url {
        padding-top: 13px;
        padding-left: 21px;
        margin-right: 20px;
        font-weight: 500;
        color: #444;
        font-size: 14px;
      }
      .meta {
        color: rgba(0, 0, 0, 0.5);
        font-weight: 500;
        position: absolute;
        left: 43px;
        bottom: 10px;
      }
    }
  }

  .inflow,
  .outflow {
    position: relative;
    top: 0;
    left: 0;
    height: 460px;
  }

  .inflow div.item {
    box-shadow: 0 5px 6px -2px rgba(0, 0, 0, 0.08);
    border: solid 2px #43b6c9;
    border-radius: 30px;
    overflow: hidden;
    .bg {
      background-color: #43b6c9;
    }
  }

  .outflow {

    & > li.item {
      box-shadow: 0 5px 6px -2px rgba(0, 0, 0, 0.08);
      border: solid 2px #9fce12;

      div.item {
        overflow: hidden;
        .bg {
          background-color: #9fce12
        }
      }

      &.item-exit {
        margin-right: 16%;
        margin-left: -10px;
        padding-left: 30px;
        background-color: #ff8400;
        border-color: #ff8400;

        .url {
          color: #fff;
          padding-left: 14px;
        }
        .meta {
          color: #fff;
          opacity: 1;
          font-weight: 500;
          left: 67px;
        }

        .item {
          .icon_exit {
            width: 25px;
            height: 32px;
            position: absolute;
            top: 16px;
            left: 27px;
            background: url(../../assets/img/icon_conversion_exit.svg) no-repeat 0 0;
          }
        }
      }
    }
  }

  .page_info {
    position: absolute;
    top: 217px;
    left: 50%;
    margin-left: -11.34%;
    width: 22.68%;
    height: 107px;
    border-radius: 53.5px;
    box-shadow: 0 15px 12px -7px rgba(0, 0, 0, 0.3);
    background-color: #2f2f2f;
    text-align: center;
    color: #fff;

    strong {
      display: block;
      padding-top: 20px;
      font-weight: 500;
      font-size: 15px;
    }
    .url {
      //margin: 11px 20px;
    }
    .match_type {
      display: inline-block;
      height: 16px;
      font-size: 12px;
      font-weight: 500;
      border-radius: 4px;
      padding: 2px 5px 0 5px;
      box-sizing: border-box;
      background-color: #8d8d8d;
    }
  }

  .btn_more_list {
    position: absolute;
    right: 12px;
    top: 50%;
    width: 34px;
    height: 34px;
    border-radius: 20px;
    border: solid 1px #bbbbbb;
    box-sizing: border-box;
    padding: 9px;
    transform: translate(0, -50%);

    .icon--more {
      margin: -1px -2px 0 0;
    }
  }
}
</style>
